module.exports = __webpack_public_path__ + "img/NW.45cf2bbc.webp";